module.exports = __webpack_public_path__ + "img/icon-instagram.58fd0d1a.svg";